import { atom } from 'recoil';

const config = atom({
  key: 'config',
  default: undefined,
});
export default config;
